export default __webpack_public_path__ + "close.asset.cb6e557b094f4d983d7b20b3b72ac46d.svg";